import {
  IonAvatar,
  IonButton,
  IonImg,
  IonItem,
  IonSkeletonText,
  IonText,
  IonThumbnail
} from "@ionic/react";
import { useField } from "formik";
import { useEffect, useRef, useState } from "react";

interface InputProps {
  label?: string;
  name: string;
  placeholder: string;
  type?: "avatar" | "item";
}
const ImgInput: React.FC<InputProps> = ({ label, ...props }) => {
  const [field, meta, helpers] = useField(props);
  const [preview, setPreview] = useState<string>();
  const fileInput = useRef(null);
  const onSelectFile = async (e: any) => {
    const file = e.target.files[0];
    if (file) {
      helpers.setValue(file);
    }
  };

  useEffect(() => {
    if (field.value) {
      if (typeof field.value === "string") {
        setPreview(field.value);
      } else {
        setPreview(URL.createObjectURL(field.value));
      }
    }
  }, [field.value]);

  return (
    <>
      <div className="pt-6">
        {props.type === "avatar" && (
          <div className="ion-text-center">
            <IonAvatar
              className="w-24 h-24 mx-auto border border-1 border-white"
              onClick={() => {
                // @ts-ignore-next-line
                fileInput?.current?.click();
              }}
            >
              {field.value && <IonImg src={preview} />}
              {!field.value && <IonSkeletonText />}
            </IonAvatar>
            <IonButton
              onClick={() => {
                // @ts-ignore-next-line
                fileInput?.current?.click();
              }}
              size="small"
              className="my-4"
              color="tertiary"
            >
              Upload Image
            </IonButton>
          </div>
        )}
        {props.type === "item" && (
          <IonItem
            lines="none"
            button
            onClick={() => {
              // @ts-ignore-next-line
              fileInput?.current?.click();
            }}
          >
            <IonThumbnail slot="start">
              <IonImg src={preview} />
            </IonThumbnail>
          </IonItem>
        )}
      </div>
      <IonText className="absolute text-red-400 -mt-20 right-12 text-sm">
        {meta.touched && meta.error}
      </IonText>
      <input
        ref={fileInput}
        hidden
        name={props.name}
        type="file"
        accept="image/*"
        onChange={onSelectFile}
      />
    </>
  );
};

export default ImgInput;
